import React from "react"
import iconFrontend from "../../../images/icon-frontend.svg";

const IconFrontend = () => (
  <img className="icon-frontend" alt="icon-frontend" src={iconFrontend}/>

)
export default IconFrontend
